import { z } from "zod";

/**
 * Schema canônico de item de pedido (venda, orçamento, pedido unificado).
 * SSOT — todos os formulários devem importar daqui.
 */
export const orderItemSchema = z.object({
  type: z.enum(["product", "service"]),
  product_id: z.string().optional(),
  service_id: z.string().optional(),
  quantity: z.number().min(0.001, "Quantidade deve ser maior que 0"),
  unit_price: z.number().min(0, "Preço deve ser maior ou igual a 0"),
  discount_percentage: z.number().min(0).max(100).default(0),
  discount_value: z.number().min(0).default(0),
  discount_type: z.enum(["percentage", "fixed"]).nullable().optional(),
  notes: z.string().optional(),
});

export type OrderItemFormValues = z.infer<typeof orderItemSchema>;
